import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  GridComponent,
  Group,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Toolbar,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  ColumnChooser,
  Resize,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import {
  AddEvent,
  DeleteEvent,
  getEvents,
  EditEvent,
} from '../../services/events/event';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setEventId, setIsEventsUpdated } from '../../redux/search.slice';
import { setLocalEventId } from '../../redux/search.slice';
import { GlobalDropDown } from '../../components/GlobalDropDown';
const FilterOptions: FilterSettingsModel = { type: 'Menu' };
const contextMenuItems = [
  {
    text: 'Navigate to Event',
    tooltipText: 'view',
    prefixIcon: 'e-view',
    id: 'view',
  },
];
const pageOptions: PageSettingsModel = {
  currentPage: 1,
  pageSize: 12,
  pageCount: 8,
  pageSizes: true,
};
const toolbarOptions = [
  {
    text: 'Add',
    tooltipText: 'Add',
    prefixIcon: 'e-add',
    id: 'add',
  },
  {
    text: 'Edit',
    tooltipText: 'Edit',
    prefixIcon: 'e-edit',
    id: 'edit',
  },
  {
    text: 'Delete',
    tooltipText: 'Delete',
    prefixIcon: 'e-delete',
    id: 'delete',
  },
  {
    text: 'Event',
    tooltipText: 'Event',
    prefixIcon: 'e-arrow',
    id: 'event',
  },
  'Search',
];
var buttonForAdd: ButtonPropsModel[];
var buttonForDelete: ButtonPropsModel[];
let event_code = '';
let event_task = '';
let description = '';
let eventId = -1;
let isEdit = false;
let gridEventObj: any;
let isRenderAllow: boolean = false;
let eventStatusDropDown: DropDownListComponent | null;
let eventTypeDropdown: DropDownListComponent | null;
const Events = () => {
  const [eventsData, setEventsData] = useState<Array<any>>([]);
  const [hideAddDialog, setHideAddDialog] = useState<boolean>(false);
  const [hideDeleteDialog, setHideDeleteDialog] = useState<boolean>(false);
  const dispatch = useDispatch();
  buttonForAdd = [
    {
      click: () => {
        SavePoint();
      },
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      },
    },
    {
      click: () => {
        setHideAddDialog(false);
      },
      buttonModel: {
        content: 'Cancel',
        isPrimary: false,
      },
    },
  ];
  buttonForDelete = [
    {
      click: () => {
        deletePoint();
      },
      buttonModel: {
        content: 'Yes',
        isPrimary: true,
      },
    },
    {
      click: () => {
        setHideDeleteDialog(false);
      },
      buttonModel: {
        content: 'No',
      },
    },
  ];
  const getEvent = () => {
    getEvents().then((result) => {
      if (isRenderAllow) {
        setEventsData(result.data);
      }
    });
  };
  const toolbarClick = (args: any) => {
    if (args.item.id === 'add') {
      isEdit = false;
      eventId = -1;
      setHideAddDialog(true);
    }
    if (args.item.id === 'edit') {
      if (gridEventObj.getSelectedRecords().length !== 0) {
        const eventData = gridEventObj.getSelectedRecords()[0];
        isEdit = true;
        event_code = eventData.eventCode;
        description = eventData.description;
        eventId = eventData.eventId;
        event_task = eventData.event_task;
        eventTypeDropdown && (eventTypeDropdown.text = eventData.type);
        eventStatusDropDown && (eventStatusDropDown.text = eventData.status);
        setHideAddDialog(true);
      } else {
        Message.error('no records selected for Event');
      }
    }
    if (args.item.id === 'delete') {
      if (gridEventObj.getSelectedRecords().length !== 0) {
        setHideDeleteDialog(true);
      } else {
        Message.error('no records selected for Event');
      }
    }
    if (args.item.id === 'event') {
      if (gridEventObj.getSelectedRecords().length !== 0) {
        const data = gridEventObj.getSelectedRecords()[0];
        dispatch(setEventId(data.eventId));
      } else {
        Message.error('no records selected for Event');
      }
    }
  };
  const SavePoint = () => {
    if (event_code === '') {
      Message.error('Event Code can not be empty');
      return false;
    }
    if (description === '') {
      Message.error('Description can not be empty');
      return false;
    }
    if (!eventTypeDropdown?.value) {
      Message.error('Type can not be empty');
      return false;
    }
    if (!eventStatusDropDown?.value) {
      Message.error('Status can not be empty');
      return false;
    }

    const obj: any = {
      app: 'UW',
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      eventCode: event_code,
      eventTask: event_task,
      description: description,
      status: eventStatusDropDown.text,
      type: eventTypeDropdown.text,
      eventId: eventId,
      creationDate: new Date(),
      complianceDate: new Date(),
    };
    if (!isEdit) {
      delete obj.eventId;
      AddEvent(obj)
        .then((res: any) => {
          Message.success('Success');
          loadingShow(false);
          getEvent();
          setHideAddDialog(false);
          dispatch(setIsEventsUpdated(true));
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    } else {
      EditEvent(obj)
        .then((res: any) => {
          Message.success('Success');
          loadingShow(false);
          getEvent();
          setHideAddDialog(false);
          dispatch(setIsEventsUpdated(true));
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    }
  };
  const deletePoint = () => {
    const data = gridEventObj.getSelectedRecords()[0];
    const obj = {
      eventId: data.eventId,
    };
    DeleteEvent(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        getEvent();
        dispatch(setIsEventsUpdated(true));
        setHideDeleteDialog(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const contextMenuClick = (args: any) => {
    if (args.item.id === 'view') {
      const data = gridEventObj.getSelectedRecords()[0];
      dispatch(setEventId(data.eventId));
      dispatch(setLocalEventId(data.eventId));
    }
  };
  useEffect(() => {
    isRenderAllow = true;
    getEvent();
    return () => {
      isRenderAllow = false;
    };
  }, []);

  return (
    <div className='parent-div-event'>
      <GridComponent
        dataSource={eventsData}
        toolbar={toolbarOptions}
        style={{ display: 'inline-grid' }}
        height={'40vh'}
        filterSettings={FilterOptions}
        ref={(g) => (gridEventObj = g)}
        gridLines={'Both'}
        allowFiltering={true}
        allowPaging={true}
        pageSettings={pageOptions}
        showColumnMenu={true}
        allowResizing={true}
        showColumnChooser={true}
        toolbarClick={toolbarClick.bind(this)}
        contextMenuItems={contextMenuItems}
        contextMenuClick={contextMenuClick.bind(this)}
        dataBound={() => {
          if (gridEventObj) {
            var searchEle = gridEventObj.element.querySelector(
              '#' + gridEventObj?.element.id + '_searchbar'
            );
            if (searchEle) {
              searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
            }
          }
        }}
      >
        <ColumnsDirective>
          <ColumnDirective
            field='organizationId'
            headerText='ORGANIZATION ID'
            visible={true}
          />
          <ColumnDirective
            field='complianceDate'
            headerText='COMPLIANCE DATE'
            textAlign='Left'
            format='dd/MM/yyyy'
            type='date'
            visible={true}
          />
          <ColumnDirective
            field='eventCode'
            headerText='EVENT CODE'
            textAlign='Left'
          />
          <ColumnDirective
            field='eventId'
            headerText='EVENT ID'
            textAlign='Left'
          />
          <ColumnDirective
            field='description'
            headerText='DESCRIPTION'
            textAlign='Left'
          />
          <ColumnDirective
            field='status'
            headerText='STATUS'
            textAlign='Left'
          />
          <ColumnDirective field='type' headerText='TYPE' textAlign='Left' />
          <ColumnDirective field='asset' headerText='ASSET' textAlign='Left' />
        </ColumnsDirective>
        <Inject
          services={[
            Toolbar,
            Filter,
            Page,
            ContextMenu,
            ColumnMenu,
            ColumnChooser,
            Resize,
            Group,
          ]}
        />
      </GridComponent>
      <div>
        <DialogComponent
          animationSettings={{
            delay: 1,
            duration: 500,
            effect: 'FadeZoom',
          }}
          visible={hideAddDialog}
          header='Event'
          close={() => setHideAddDialog(false)}
          open={() => setHideAddDialog(true)}
          buttons={buttonForAdd}
          width={'500px'}
          isModal
          showCloseIcon
        >
          <div className='flex-elementAlias'>
            <div className='col-md-12'>
              <TextBoxComponent
                placeholder='Event Code'
                floatLabelType='Auto'
                value={event_code}
                onChange={(e: any) => {
                  event_code = e.target.value;
                }}
              />
            </div>
          </div>
          <div className='flex-elementAlias'>
            <div className='col-md-12'>
              <TextBoxComponent
                placeholder='Event Description'
                floatLabelType='Auto'
                value={description}
                onChange={(e: any) => {
                  description = e.target.value;
                }}
              />
            </div>
          </div>
          <div className='flex-elementAlias'>
            <div className='col-md-12'>
              <GlobalDropDown
                id='as-event-status'
                placeHolder='Select a event status'
                field={{ value: 'id', text: 'statusCode' }}
                refDD={(scope: DropDownListComponent) =>
                  (eventStatusDropDown = scope)
                }
                url='event-status'
                floatLabelType='Always'
              />
            </div>
          </div>
          <div className='flex-elementAlias'>
            <div className='col-md-12'>
              <GlobalDropDown
                id='as-event-type'
                placeHolder='Select a event type'
                field={{ value: 'id', text: 'typeCode' }}
                refDD={(scope: DropDownListComponent) =>
                  (eventTypeDropdown = scope)
                }
                url='event-type'
                floatLabelType='Always'
              />
            </div>
          </div>
        </DialogComponent>
      </div>
      <DialogComponent
        animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
        visible={hideDeleteDialog}
        header='Delete Event'
        close={() => setHideDeleteDialog(false)}
        open={() => setHideDeleteDialog(true)}
        buttons={buttonForDelete}
        width={'222px'}
        isModal
        showCloseIcon
      >
        <div>
          <p>Are you sure?</p>
        </div>
      </DialogComponent>
    </div>
  );
};
export default Events;
